console.log("FRONTEND");

import $ from 'jquery';

// Define interfaces for your nonce objects
interface NonceObject {
    nonce: string;
    ajaxurl: string;
}


// DOM Ready function
jQuery(function() {
    'use strict';
    
    function wiingaAjaxCaller(data: Record<string, any>, url: string): JQuery.jqXHR<any> {
        return $.ajax({
            type: "POST",
            url: url,
            dataType: 'json',
            data: data
        });
    }
    
    $(".toggle-password").on("click", function (this: HTMLElement) {
        const $this = $(this);
        $this.toggleClass("fa-eye fa-eye-slash");
        
        const toggleAttr = $this.attr("toggle");
        
        if (toggleAttr) {
            const $input = $(toggleAttr);
            
            if ($input.attr("type") === "password") {
                $input.attr("type", "text");
            } else {
                $input.attr("type", "password");
            }
        }
    });
    
});